<template>
  <header class="timeline-header">
    <button @click="close" class="g-nav-mobile__close">
      <Icon icon="close-btn" />
    </button>
  </header>
</template>

<script>
import { Icon } from "@international-energy-agency/vue-ui";
export default {
  components: {
    Icon,
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style>
.timeline-header {
  height: 60px;
  width: inherit;
  display: flex;
  background-color: #fff;
  justify-content: flex-end;
  border-bottom: 1px solid;
  border-color: #e6e6e6;
}
</style>
